import { GameSoundLiftEvents } from "../event/GameSountEvent";
import { SoundController } from "@lib/titan2-slingo/dist/game/controller/SoundController";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
export class GameSoundLiftController extends SoundController {
    constructor(factory) {
        super(factory);
        Logger.addObjectRef(this);
    }
    addEventListeners() {
        super.removeEventListeners();
        this.registerGame(GameSoundLiftEvents.OPEN_LIFT, this.handleOpenLift);
        this.registerGame(GameSoundLiftEvents.CLOSE_LIFT, this.handleCloseLift);
        this.registerGame(GameSoundLiftEvents.BEGIN_LOOP, this.handleBeginLoop);
        this.registerGame(GameSoundLiftEvents.END_LOOP, this.handleEndLoop);
        this.registerGame(GameSoundLiftEvents.PLAY_BELL, this.handlePlayBell);
    }
    handleOpenLift() {
        this.playSound(this.getSoundPropertiesFromId("LIFT_OPEN")).volume(2);
    }
    handleCloseLift() {
        this.playSound(this.getSoundPropertiesFromId("LIFT_CLOSE")).volume(2);
    }
    handleBeginLoop() {
        this.playSound(this.getSoundPropertiesFromId("LIFT_LOOP")).volume(5);
    }
    handleEndLoop() {
        this.stopSound(this.getSoundPropertiesFromId("LIFT_LOOP"));
    }
    handlePlayBell() {
        const matchedPatterns = this.model.getCurrentMatchedPatterns();
        const soundId = `LIFT_BELL_${matchedPatterns}`;
        const sound = this.getSoundPropertiesFromId(soundId);
        if (sound) {
            this.playSound(sound).volume(2);
        }
    }
}
//# sourceMappingURL=GameSoundLiftController.js.map